module.exports = __webpack_public_path__ + "images/50free-tokenmodal-2c306ada2415c76e88f546fcb54d8cbc.jpg";